import React from "react";

const BaseDialog = ({ title, children, actions }) => (
  <div className="bg-white rounded-lg p-6 w-full max-w-md m-4">
    {title && <h2 className="text-xl font-bold mb-4">{title}</h2>}
    <div className="mb-4">{children}</div>
    <div className="flex justify-end gap-4">{actions}</div>
  </div>
);

export default BaseDialog; 